import { memo, useCallback, useMemo } from 'react';
import { getLiteral, getLiteralWithParameters } from 'utils/getLiteral';
import AdvancedSelect from 'components/AdvancedSelect';
import SelectHoi from 'components/SelectHoi';
import { getDayWeekOptions } from '../../../../../../utils';

import './styles.scss';

const InputWeekDayOperatorForm = memo(
    ({ onChange, value = [], options, defaultFilter, filterOptions, triggerEntityDescription }) => {
        const innerOnChange = useCallback(
            (v, idx) => {
                let newValue = value || [];
                newValue[idx] = v;
                onChange(newValue);
            },
            [onChange, value],
        );

        const dayWeekOptions = useMemo(() => getDayWeekOptions(), []);

        // Format the value to include entity in parentheses
        const formattedValue = useMemo(() => {
            let currentValue = value[0];
            if (currentValue && typeof currentValue === 'object' && currentValue.value) {
                // Extract entity from template format {{ .entity.field }}
                // Get all segments except the last one
                const match = currentValue.value.match(/\{\{\s*\.(.+?)\s*\}\}/);
                let entityKey = null;
                if (match) {
                    const segments = match[1].split('.');
                    // Remove the last segment (the field name)
                    segments.pop();
                    entityKey = segments.join('.');
                }

                let valueLabel = currentValue.label;
                if (entityKey) {
                    const entityInfo = filterOptions?.find((filter) => filter.value === entityKey);
                    if (entityInfo) {
                        valueLabel = `${currentValue.label} (${entityInfo.label})`;
                    } else if (entityKey === 'event.data' && triggerEntityDescription) {
                        valueLabel = `${currentValue.label} (${getLiteralWithParameters(
                            'label_automation_entity_trigger',
                            [getLiteral(triggerEntityDescription)],
                        )})`;
                    }
                }

                return {
                    ...currentValue,
                    label: valueLabel,
                };
            }
            return currentValue;
        }, [value, filterOptions, triggerEntityDescription]);

        return (
            <>
                <SelectHoi
                    options={dayWeekOptions}
                    value={value[1]}
                    onChange={(v) => innerOnChange(v, 1)}
                    usePlainValue
                    isFullWidth
                    useMenuPortal={false}
                />
                <AdvancedSelect
                    filterPlaceholder={getLiteral('label_placeholder_entity')}
                    searchPlaceholder={getLiteral('placeholder_search_field')}
                    menuTitle={getLiteral('cfm_action_add_field')}
                    placeholder={getLiteral('label_placeholder_field')}
                    value={formattedValue}
                    onChange={(v) => innerOnChange(v, 0)}
                    options={options}
                    defaultFilter={defaultFilter}
                    filterOptions={filterOptions}
                    isFullWidth
                    useMenuPortal={false}
                />
            </>
        );
    },
);

export default InputWeekDayOperatorForm;
